import { Injectable } from '@angular/core';

import { ContractType } from '@app-model/api';
import { ContractFilterDateType, ContractFilterStatusType, HistoryFilter } from '@app-model/history-filter';

import { SortingService } from './sorting.service';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  static fetchContractGroup(contracts: ContractType[]): ContractFilterDateType[] {
    return contracts.reduce((prevVal, elem) => {
      const index = prevVal.some((item) => item.name === elem.contractGroup1);
      if (!index) {
        prevVal.push(new ContractFilterDateType(elem.contractGroup1));
      }

      return prevVal;
    }, []);
  }

  static fetchStatus(contracts: ContractType[]): ContractFilterDateType[] {
    const status = contracts.reduce((prevVal, elem) => {
      const index = prevVal.some((item) => item.name === elem.status);

      if (!index) {
        prevVal.push(new ContractFilterStatusType(elem.status));
      }

      return prevVal;
    }, []);

    return SortingService.sortStrings(status);
  }

  static fetchHistoryFilters(contracts: ContractType[]): HistoryFilter {
    if (contracts) {
      const month: ContractFilterDateType[] = this.fetchContractGroup(contracts);
      const status: ContractFilterStatusType[] = this.fetchStatus(contracts);

      return new HistoryFilter(month, status);
    }
  }

  ////////// STATIC FILTER CONTRACTS ////////////////////////////////////////////////////////
  static filter(filters: HistoryFilter, contracts: ContractType[]): ContractType[] {
    const secondLevelFilteredContracts = this.filterByMonth(filters, contracts);

    return this.filterByStatus(filters, secondLevelFilteredContracts);
  }

  static filterByMonth(pendingContractFilter: HistoryFilter, contracts: ContractType[]): ContractType[] {
    const selectedMonthFilters = [];

    pendingContractFilter.month.forEach((filter) => {
      if (filter.selected) {
        selectedMonthFilters.push(filter);
      }
    });

    if (pendingContractFilter.month.length === selectedMonthFilters.length || !selectedMonthFilters.length) {
      return contracts;
    }

    const filteredContracts = [];

    contracts.forEach((contract: ContractType) => {
      const monthFilter = pendingContractFilter.month.find(
        (filter: ContractFilterStatusType) => filter.name === contract.contractGroup1 && filter.selected
      );

      if (monthFilter) {
        filteredContracts.push(contract);
      }
    });

    return filteredContracts;
  }

  static filterByStatus(pendingContractFilter: HistoryFilter, contracts: ContractType[]): ContractType[] {
    const selectedStatusFilters = [];

    pendingContractFilter.status.forEach((filter, index) => {
      if (filter.selected) {
        selectedStatusFilters.push(filter);
      }
      pendingContractFilter.status[index].display = false;
    });

    if (pendingContractFilter.status.length === selectedStatusFilters.length || !selectedStatusFilters.length) {
      pendingContractFilter.status.forEach((_, index) => (pendingContractFilter.status[index].display = true));

      return contracts;
    }

    const filteredContracts = [];

    contracts.forEach((contract: ContractType) => {
      const statusFilter = pendingContractFilter.status.find(
        (filter: ContractFilterStatusType) => filter.name === contract.status && filter.selected
      );

      if (statusFilter) {
        statusFilter.display = true;

        filteredContracts.push(contract);
      }
    });

    return filteredContracts;
  }
}
